import React from "react";
import { useResponsiveBelowMd } from "src/hooks";
import { ActionSectionProps } from "./types";
import { ActionSectionBelowMd } from "./ActionSection.belowMd";
import { ActionSection } from "./ActionSection";

export default function ActionSectionResponsive(props: ActionSectionProps) {
  const isBelowMd = useResponsiveBelowMd();
  return isBelowMd ? (
    <ActionSectionBelowMd {...props} />
  ) : (
    <ActionSection {...props} />
  );
}
